export const url = {
  whitebricksApi: "https://docs.finbricks.com/",
  finbricks: "https://finbricks.com/",
  jistotaFoundation: "https://www.kb.cz/cs/nadace-kb",
  jistotaFoundationProjects: "https://www.kb.cz/cs/nadace-kb/oblasti-podpory",
  jistotaFoundationForDonors: "https://www.kb.cz/cs/nadace-kb/pro-darce",
  customizationCs: "/files/whitebricks_customization_cs.pdf",
  customizationEn: "/files/whitebricks_customization_en.pdf",
  privacyPolicy: "https://www.kb.cz/cs/ochrana-osobnich-udaju",
};